import { render, staticRenderFns } from "./portal-notas.vue?vue&type=template&id=7f4e9166&"
import script from "./portal-notas.vue?vue&type=script&lang=js&"
export * from "./portal-notas.vue?vue&type=script&lang=js&"
import style0 from "./portal-notas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports